interface DailyMetrics {
    clicks: number;
    impressions: number;
    viewDuration: number; // Average view duration in seconds
}

interface VariationMetrics {
    totalClicks: number;
    totalImpressions: number;
    avgViewDuration: number;
    dailyMetrics: {
        [date: string]: DailyMetrics;
    };
    weeklyMetrics: {
        [weekStart: string]: DailyMetrics;
    };
    monthlyMetrics: {
        [monthStart: string]: DailyMetrics;
    };
}

interface Analytics {
    campaignId: string;
    totalClicks: number;
    totalImpressions: number;
    avgViewDuration: number; // in seconds
    
    // Per-variation metrics (new)
    variations?: {
        [variationId: string]: VariationMetrics;
    };
    // Daily metrics for the last 30 days
    dailyMetrics: {
        [date: string]: DailyMetrics;
    };
    
    // Weekly metrics (last 4 weeks)
    weeklyMetrics: {
        [weekStart: string]: DailyMetrics;
    };
    
    // Monthly metrics (last 12 months)
    monthlyMetrics: {
        [monthStart: string]: DailyMetrics;
    };
    
    lastUpdated: Date;
}

export function createEmptyAnalytics(campaignId: string): Analytics {
    return {
        campaignId,
        totalClicks: 0,
        totalImpressions: 0,
        avgViewDuration: 0,
        variations: {},
        dailyMetrics: {},
        weeklyMetrics: {},
        monthlyMetrics: {},
        lastUpdated: new Date()
    };
}

export type { Analytics, DailyMetrics, VariationMetrics }; 